<template>
    <b-card>
        <div class="card-header">
           <h5 class="card-title mb-0"><b>{{ $t('DelayedOnTime') }}</b></h5>
        </div>
        <div class="card-body">
            <div class="mb-3">
                <div class="d-flex mt-2">
                    <div class="flex-shrink-0 avatar-xs align-self-center me-3" >
                        <div :class="`avatar-title bg-dark rounded-circle fs-16 text-white`" >
                            <i class="bx bx-collection"></i>
                        </div>
                    </div>
                    <div :class="`flex-grow-1 overflow-hidden`" >
                        <p class="mb-1 fs-16">{{ $t('DelayedOnTime') }} :</p>
                        <div class="ctext-wrap" style="display:flex">
                            <div class="ctext-wrap-content">
                                <h6 :class="`fs-14 mb-0 fw-normal copy`" >{{ this.form.delayedDatetime }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>   
            <div class="mb-3">
                <div class="d-flex mt-2">
                    <div class="flex-shrink-0 avatar-xs align-self-center me-3" >
                        <div :class="`avatar-title bg-dark rounded-circle fs-16 text-white`" >
                            <i class="bx bxs-phone"></i>
                        </div>
                    </div>
                    <div :class="`flex-grow-1 overflow-hidden`" >
                        <p class="mb-1 fs-16">{{ $t('phone_number') }} :</p>
                        <div class="ctext-wrap" style="display:flex">
                            <div class="ctext-wrap-content">
                                <h6 :class="`fs-14 mb-0 fw-normal copy`" @click="copy(form.userPhone)" >{{ form.userPhone }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="d-flex mt-2">
                    <div class="flex-shrink-0 avatar-xs align-self-center me-3" >
                        <div :class="`avatar-title bg-dark rounded-circle fs-16 text-white`" >
                            <i class="bx bxs-user"></i>
                        </div>
                    </div>
                    <div :class="`flex-grow-1 overflow-hidden`" >
                        <p class="mb-1 fs-16">{{ $t('Manager') }} :</p>
                        <div class="ctext-wrap" style="display:flex">
                            <div class="ctext-wrap-content">
                                <h6 :class="`fs-14 mb-0 fw-normal copy`" @click="copy(this.nameWorker(form.delayWorkerId))" >{{ this.nameWorker(form.delayWorkerId) }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
import { nameWorker } from '@/usabilityScripts/getNameWorker'
import { storeS } from '@/store'
import {copy} from '@/usabilityScripts/copy.js'

export default{
    props: ['obj'],
    data(){
        return {
            form: ''
        }
    },
    created(){
        this.form = this.obj
    },
    methods: {
        nameWorker(item){
            return nameWorker(item)
        },
        copy(item){
            // копіювання
            if(copy(item) == true) {
                this.$toast.success(this.$t('Copied'));
            } else {
                this.$toast.error(`Fucking mistake, contact Borys`);
            }
            return
        },
    },
    computed:{
        perms() {
            return storeS.perms
        },
        user() {
            return storeS.userbase
        }
    }
}

</script>